import axios from 'axios'
import './common'

export default {
  getIcsUri: () => axios.get(`/users/ics-uri`),
  updatePassword: (data) => axios.put(`/users/password`, data),
  updatePersonalInfo: (data) => axios.put(`/users/update`, data),
  updateParamsUserInfo: (id, data) => axios.put(`/params/users/${id}?pdata_only=1`, data),
  show(id) {
    return axios.get(`/params/users/${id}`)
  }
}
